module.exports = __webpack_public_path__ + "static/img/281_TO8_2423.8f81aec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/281_TO8_2423.jpg
// module id = 2Ikw
// module chunks = 0